export default function SearchBar({data, onSearch}) {
    return (
        <div className="searchContainer">
            <input
                type='text'
                className="searchBar"
                placeholder="Buscar..."
                onChange={(e) => onSearch(e.target.value)}
            />
        </div>
    );
}
